import axiosPrivate from "./axiosPrivate";

const getControlPoi = () => {
  return axiosPrivate.get("control-poi")
    .then(response => response.data);
};

const insertControlPoi = (data) => {
    return axiosPrivate.post("control-poi", data)
        .then(response => response.data);
};

const updateControlPoi = (data) => {
    return axiosPrivate.put("control-poi", data)
        .then(response => response.data);
};

export default {
    getControlPoi,
    insertControlPoi,
    updateControlPoi
};